export default __webpack_public_path__ + "static/media/campagna_vaccinale_cover.c4ba5e02.png";